import { ref } from 'vue';
import { getDocumentPrefixes } from '../api/document-prefixes.api';

interface DocumentPrefix {
  id: number;
  code: string;
  name: string;
}

export default function useDocumentPrefixes() {
  const prefixOptions = ref<{ id: number | string; name: string }[]>([]);
  const selectedPrefix = ref<number | string>('');
  const isLoading = ref(false);

  const fetchPrefixes = async () => {
    try {
      isLoading.value = true;
      const prefixes: DocumentPrefix[] = await getDocumentPrefixes();
      prefixOptions.value = prefixes.map((prefix) => ({
        id: prefix.id,
        name: `${prefix.code}`,
      }));

      const daPrefix = prefixes.find((p) => p.code === 'DA');
      if (daPrefix) {
        selectedPrefix.value = daPrefix.id;
      }
    } catch (error) {
      console.error('Erro ao buscar prefixos:', error);
    } finally {
      isLoading.value = false;
    }
  };

  return {
    prefixOptions,
    selectedPrefix,
    isLoading,
    fetchPrefixes,
  };
}
